import unset from 'lodash/unset'
import { config } from '../../../components/Init/Init'
import _ from 'lodash'

/**
 * @des this method omit 'modals.taxIdRequired' from income state object and set it to localStorage
 * @param {object} state - player data object
 * @return void
 */
export const setAppTokenLocalStorage = state => {
  const cloneState = _.cloneDeep(state)

  if (state.modals && state.modals.taxIdRequired) {
    unset(cloneState, 'modals.taxIdRequired')
  }

  try {
    localStorage.setItem(config.appToken, JSON.stringify(cloneState))
  } catch (e) {
    if (e.name === 'QuotaExceededError') {
      localStorage.removeItem(config.appToken)
      localStorage.setItem(config.appToken, JSON.stringify(cloneState))
    }
  }
}
